import DessertFoodsComponent from "../../../NonMVPComponents/Recipes/Desserts/DessertFoodsComponent";

const DessertFoods = () => {
  return (
    <div>
      <DessertFoodsComponent />
    </div>
  );
};

export default DessertFoods;
